 export const sortPerspectives = (rawPerspectives) => {
    const pers = rawPerspectives.map((per) => {
    
        
      if ((per?.perspective_name.indexOf("Financial") >= 0)) {
        return {
          ...per,
          order: 1,
        };
      } else if ((per?.perspective_name.indexOf("Customer") >= 0)) {
        return {
          ...per,
          order: 2,
        };
      } else if ((per?.perspective_name.indexOf("Processes") >= 0)) {
        return {
          ...per,
          order: 3,
        };
      } else if ((per?.perspective_name.indexOf("Learning") >= 0)) {
        return {
          ...per,
          order: 4,
        };
      } else if ((per?.perspective_name.indexOf("Behavioral") >= 0 )) {
        return {
          ...per,
          order: 5,
        };
      }
    });

    return pers.sort((a, b) => a.order - b.order);
  };

   export const sortConfigPerspectives = (rawPerspectives) => {
    const pers = rawPerspectives.map((per) => {
    
        
      if ( (per.name.indexOf("Financial") >= 0)) {
        return {
          ...per,
          order: 1,
        };
      } else if ( (per.name.indexOf("Customer") >= 0)) {
        return {
          ...per,
          order: 2,
        };
      } else if ( (per.name.indexOf("Processes") >= 0)) {
        return {
          ...per,
          order: 3,
        };
      } else if ( (per.name.indexOf("Learning") >= 0)) {
        return {
          ...per,
          order: 4,
        };
      } else if ( (per.name.indexOf("Behavioral") >= 0)) {
        return {
          ...per,
          order: 5,
        };
      }
    });

    return pers.sort((a, b) => a.order - b.order);
  };